import { ResolvedComponentsConfiguration } from "@zoovu/runner-browser-api";
import globals from "./global-variables";
import stylesConfig from "../styles.config";

export const CheckboxStyle = {
  padding: "5px",
  alignItems: "center",
  textAlign: "center",
  content: "''",
  width: "15px",
  height: "15px",
  borderRadius: "3px",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "0px -103px",
  backgroundColor: stylesConfig.colors.primaryAccentColorVariants.gray,
};

export const CheckboxStyleSelected = {
  ...CheckboxStyle,
  backgroundColor: stylesConfig.colors.primaryAccentColorVariants.gray,
  backgroundImage: (configuration: ResolvedComponentsConfiguration): string => `${globals.sprite(configuration)}`,
  backgroundRepeat: "no-repeat",
  backgroundPosition: "-14px -69px",
  backgroundSize: "229px 229px",
};
